export default "__VITE_ASSET__95cvMojy__"